import './ChangeActiveBlock.css';
import React from "react";
import workingBlocks from '../assets/constants/workingBlocks.js';

function ChangeActiveBlock(props) {
    return (
        <div className="workingBody">
                <div className="activeBlockBoxRow">
                    <div className="boxLineActiveBlock"></div>
                     {workingBlocks.map((block, index) => (
                        <div key={index}>
                        <div className="boxActiveBlock" onClick={()=>props.setActiveBlock({startHour: 0, endHour: 0, workingBlock: block, subtype: "unspecified"})}>
                        <div className={props.activeBlock.workingBlock === block ? "innerBoxBlock innerBoxBlockActive" : "innerBoxBlock"}> </div>
                        </div>
                        <p className="blockOptionTitle"> {block.title}</p>
                    </div>
                     ))}
                </div>
        </div>
    )
}

export default ChangeActiveBlock;